import { ProjectGuard } from "../guards";

export const ProjectWorkspaceLayout = () => <ProjectGuard />;
